// extracted by mini-css-extract-plugin
export default {"container":"GUS5nb78TJ","pagination":"D2CzELeXPa","pagination-cell":"iVMStxz7PW","paginationCell":"iVMStxz7PW"};